/**
 * onboarding-service.js
 *
 * Persists whether a user has seen each first-run tour.
 *
 * Firestore layout:
 *   users/{uid}.hasSeenOnboarding          — Dashboard tour
 *   users/{uid}.hasSeenCoinDetailOnboarding — Coin Detail page tour
 * Both are set to false when the doc is first created (auth-context.js),
 * flipped to true once that tour finishes or is skipped. A missing field
 * (accounts created before a given tour shipped) is treated as "not yet
 * seen" too — see auth-context.js's syncUserTier().
 */

import { db } from './firebase-config';
import { doc, setDoc } from 'firebase/firestore';

export async function markOnboardingSeen(uid) {
  await setDoc(doc(db, 'users', uid), { hasSeenOnboarding: true }, { merge: true });
}

export async function markCoinDetailOnboardingSeen(uid) {
  await setDoc(doc(db, 'users', uid), { hasSeenCoinDetailOnboarding: true }, { merge: true });
}
